import { render, staticRenderFns } from "./PaxelRecycleCoverage.vue?vue&type=template&id=541cbb1d&"
import script from "./PaxelRecycleCoverage.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports